<template>
  <button type="button" v-focus class="go-back-button back" @click="navigate">
    <i class="fa-solid fa-chevron-left" />
    <slot>Retour à la liste</slot>
  </button>
</template>

<script setup lang="ts">
import { useRouter } from "vue-router";

type GoBackButtonProps = {
  path?: string;
  goBack?: boolean;
};

const { path, goBack = false } = defineProps<GoBackButtonProps>();

const router = useRouter();

const navigate = () => {
  if (goBack) {
    router.back();
  } else if (path) {
    router.push(path);
  }
};
</script>

<style scoped lang="scss">
.go-back-button {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 2px;
  width: fit-content;
}
</style>
